
export default {
  name: 'DaisoStaticImage',
  inheritAttrs: false,
  props: {
    src: {
      type: [String, null],
      default: null
    },
    alt: {
      type: String,
      default: ''
    },
    imageClass: {
      type: String,
      default: ''
    },
    priority: {
      type: Boolean,
      default: false
    },
    loading: {
      type: String,
      default: null
    },
    fetchpriority: {
      type: String,
      default: null
    },
    decoding: {
      type: String,
      default: 'async'
    },
    fallbackEnabled: {
      type: Boolean,
      default: true
    },
    error: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      isErrorHandled: false,
      noImagePath: '/images/tempLy/noimage.png',
      currentSrc: null
    }
  },
  computed: {
    nativeListeners () {
      const listeners = { ...this.$listeners }
      delete listeners.load
      delete listeners.error
      return listeners
    },
    effectiveLoading () {
      return this.loading || (this.priority ? 'eager' : 'lazy')
    },
    effectiveFetchpriority () {
      return this.fetchpriority || (this.priority ? 'high' : 'auto')
    },
    processedSrc () {
      if (!this.src) {
        return this.fallbackEnabled ? this.fallbackSrc : this.src
      }
      if (this.isErrorHandled) {
        return this.fallbackEnabled ? this.fallbackSrc : this.src
      }
      return this.src
    },
    fallbackSrc () {
      return this.error || this.noImagePath
    }
  },
  watch: {
    src: {
      immediate: true,
      handler () {
        this.isErrorHandled = false
        this.currentSrc = this.processedSrc
      }
    }
  },
  methods: {
    load (event) {
      this.$emit('load', event)
    },
    errorImage (event) {
      if (!this.isErrorHandled) {
        this.isErrorHandled = true
        if (this.fallbackEnabled) {
          this.currentSrc = this.fallbackSrc
        }
        this.$emit('error', event)
      }
    }
  }
}
